import type { UserOrderSlice } from '@/hooks/useUserKalshiPOS';

interface QueueMetric {
  queue: number | null;
  queueAbove: number | null;
}

export interface QueueAlertMetric extends QueueMetric {
  sourceSampleToken?: string;
  /** Pause comparison only; retained prices never become alert evidence. */
  pauseForBookRecovery?: boolean;
}

/** Display may retain a queue or show an at-level lower bound. Neither proves
 * a cumulative queue crossing. Alerts require this order's strict reading
 * plus a currently admitted book (zero better-priced contracts is valid). */
export function queueAlertEvidence(
  displayedMetrics: ReadonlyMap<string, QueueMetric>,
  strictOrders: ReadonlyMap<string, UserOrderSlice>,
  recoveringBookOrderIds?: ReadonlySet<string> | ReadonlyMap<string, unknown>,
): Map<string, QueueAlertMetric> {
  const result = new Map<string, QueueAlertMetric>();
  for (const [id, metric] of displayedMetrics) {
    const order = strictOrders.get(id);
    const atLevel = order?.queuePosition;
    const above = metric.queueAbove;
    const validQueue = atLevel != null && Number.isFinite(atLevel) && atLevel >= 0;
    const valid = validQueue &&
      above != null && Number.isFinite(above) && above >= 0;
    result.set(id, {
      queue: valid ? atLevel + above : null,
      queueAbove: valid ? above : null,
      ...(validQueue && above == null && recoveringBookOrderIds?.has(id)
        ? { pauseForBookRecovery: true } : {}),
      ...(order?.queueObservedAtMs != null
        ? { sourceSampleToken: `row:${order.queueObservedAtMs}` } : {}),
    });
  }
  return result;
}
